module.exports = global.config = {
    i18n: {
        welcome: {
            url: "",
            dispName: ""
        }
        // rest of your translation object
    }
    // other global config variables you wish
};